import { render, staticRenderFns } from "./productinfo.vue?vue&type=template&id=4d010d86&scoped=true&"
import script from "./productinfo.vue?vue&type=script&lang=js&"
export * from "./productinfo.vue?vue&type=script&lang=js&"
import style0 from "./productinfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./productinfo.vue?vue&type=style&index=1&id=4d010d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d010d86",
  null
  
)

export default component.exports